import { render, staticRenderFns } from "./DrawerPop.vue?vue&type=template&id=0c13c3a8&scoped=true&"
import script from "./DrawerPop.vue?vue&type=script&lang=js&"
export * from "./DrawerPop.vue?vue&type=script&lang=js&"
import style0 from "./DrawerPop.vue?vue&type=style&index=0&id=0c13c3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13c3a8",
  null
  
)

export default component.exports